import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-2 place-items-end no-print"
};
const _hoisted_2 = {
  class: "px-2 pb-0.5"
};
const _hoisted_3 = {
  class: "pagination"
};
const _hoisted_4 = {
  class: "pagination-item"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  class: "pagination-item"
};
const _hoisted_7 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LlSelect = _resolveComponent("LlSelect");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_LlSelect, {
    "model-value": $props.perPage,
    items: $options.perPageOptions,
    "item-value": "value",
    "return-object": false,
    placeholder: "Rows per Page",
    clearable: false,
    "hide-details": true,
    "onUpdate:modelValue": $options.perPageChanged
  }, null, 8, ["model-value", "items", "onUpdate:modelValue"]), _createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString($options.initialPageValue) + " - " + _toDisplayString($options.offsetPageValue) + " of " + _toDisplayString($props.totalItems) + " ", 1), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createElementVNode("button", {
    type: "button",
    class: "py-2 px-3 border",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClickPreviousPage && $options.onClickPreviousPage(...args)),
    disabled: $options.isInFirstPage,
    "aria-label": "Go to previous page"
  }, [...(_cache[2] || (_cache[2] = [_createElementVNode("i", {
    class: "fa fa-angle-left"
  }, null, -1)]))], 8, _hoisted_5)]), _createElementVNode("li", _hoisted_6, [_createElementVNode("button", {
    type: "button",
    class: "py-2 px-3 border",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onClickNextPage && $options.onClickNextPage(...args)),
    disabled: $options.isInLastPage,
    "aria-label": "Go to next page"
  }, [...(_cache[3] || (_cache[3] = [_createElementVNode("i", {
    class: "fa fa-angle-right"
  }, null, -1)]))], 8, _hoisted_7)])])])]);
}